import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { StakeholderDto } from '@cradua/data';
import { StakeholderFacade } from '../../../states/+stakeholder/stakeholder.facade';

@Component({
  selector: 'mrsoftapps-stakeholdersearch',
  templateUrl: './stakeholdersearch.component.html',
  styleUrls: ['./stakeholdersearch.component.css'],
})
export class StakeholdersearchComponent implements OnInit {
  @Output() selectedStakeholder = new EventEmitter<StakeholderDto>();
  stakeholders$: Observable<StakeholderDto[]>;
  stakeholders: StakeholderDto[];
  filteredstakeholders: StakeholderDto[];
  searchvalue: string;
  constructor(private stakeholderFacade: StakeholderFacade) {}

  ngOnInit() {
    this.stakeholderFacade.loadStakeholder.subscribe((data) => {
      this.stakeholders = data;
    });
  }

  searchStakeholder() {
    if (this.searchvalue.length === 0) {
      this.filteredstakeholders = [];
      return;
    }
    let searched = this.searchvalue.toLowerCase();
    this.filteredstakeholders = this.stakeholders.filter((n) =>
      n.Fullname.toLowerCase().includes(searched)
    );

    console.log('Found Data ', this.filteredstakeholders);
  }

  public fullPhoneEmail(stakeholder: StakeholderDto, type: string): string {
    let phonecommaseparated: string;
    let phoneNumberArray = stakeholder.stakeholderContacts.filter(
      (n) =>
        n.contactType !== undefined &&
        n.contactType.ContactTypeName.toLowerCase().includes(type)
    );

    phoneNumberArray.map((phone) => {
      if (phonecommaseparated) {
        phonecommaseparated =
          phonecommaseparated + ',' + phone.StakeholderContactValue;
      } else {
        phonecommaseparated = phone.StakeholderContactValue;
      }
    });

    return phonecommaseparated;
  }

  selectStakeholder(stakeholder: StakeholderDto) {
    console.log('Reaching Select', stakeholder);

    this.selectedStakeholder.emit(stakeholder);

    this.filteredstakeholders = [];
  }
}
